import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=10700936&scoped=true&"
import script from "./TransactionList.vue?vue&type=script&lang=js&"
export * from "./TransactionList.vue?vue&type=script&lang=js&"
import style0 from "./TransactionList.vue?vue&type=style&index=0&id=10700936&prod&scoped=true&lang=css&"
import style1 from "./TransactionList.vue?vue&type=style&index=1&id=10700936&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10700936",
  null
  
)

export default component.exports